<template>
  <div
      ref="sliderContainer"
      @mousemove="onMouseMove"
      @mouseup="onMouseUp"
      class="slider-verify-container"
      @mouseleave="onMouseLeave"
  >
    <span v-if="blockState === 0">请按住滑块，拖动到最右边</span>
    <div
        @mousedown="onMouseDown"
        :style="{ left: leftP }"
        class="slider-verify-block"
    />
    <div :style="{ width: leftP }" class="slider-verify-complete">
      <span v-if="blockState === 2">验证成功</span>
    </div>
  </div>
</template>
<script setup>
import {ref, defineEmits} from "vue";
import {defineProps} from 'vue'

const params = defineProps({
  showWidth: {
    type: Number, default: 240
  },
  blockWidth: {
    type: Number, default: 40
  },
})

const emit = defineEmits(["success", "failed"]);
const leftP = ref("0");
const blockState = ref(0);
const startP = ref(undefined);
const sliderContainer = ref(undefined);

const onMouseDown = (event) => {
  if (blockState.value !== 2) {
    leftP.value = "0";
    blockState.value = 1;
    startP.value = {
      clientX: event.clientX,
    };
  } else {
    leftP.value = "0";
    blockState.value = 0;
  }
};
const onMouseMove = (event) => {
  if (blockState.value === 1) {
    let width = event.clientX - startP.value.clientX;
    if (width + params.blockWidth > params.showWidth) {
      leftP.value = params.showWidth - params.blockWidth + "px";
      blockState.value = 2;
      emit("success");
    } else {
      leftP.value = width + "px";
    }
  }
};
const onMouseUp = () => {
  if (blockState.value !== 2) {
    leftP.value = "0";
    blockState.value = 0;
    emit("failed");
  }
};
const onMouseLeave = () => {
  if (blockState.value !== 2) {
    leftP.value = "0";
    blockState.value = 0;
    emit("failed");
  }
};</script>

<style scoped>
.slider-verify-container {
  width: 100%;
  height: 40px;
  background-color: transparent;
  position: relative;
  border: solid 1px #e8e8e8;
  text-align: center;
  color: #666;
  line-height: 40px;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}

.slider-verify-complete {
  width: 0;
  height: 40px;
  position: absolute;
  background-color: #6c6;
  left: 0;
  top: 0;
}

.slider-verify-block {
  width: 40px;
  height: 40px;
  background-image: url('@/assets/picture/main/slide/arrow.png');
  background-color: gray;
  position: absolute;
  left: 0;
  top: -1px;
  border: solid 1px #eee;
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
